import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import ModelRow from '../ModelRow/index.jsx';

const BodyStyleSection = ({
  seriesModelsForBodyStyle,
  name,
  selectedModelId,
  totalUnits,
  totalSubmitted,
}) => (
  <div className={styles.bodyStyleSection}>
    <div className={styles.bodyStyleName}>
      <div className={styles.name}>{name}</div>
      <div>
        {' '}
        {totalSubmitted} / {totalUnits}
      </div>
    </div>

    <div>
      {seriesModelsForBodyStyle.map(model => (
        <ModelRow
          key={model.id}
          model={model}
          modelId={model.id}
          selectedModelId={selectedModelId}
        />
      ))}
    </div>
  </div>
);

export default enhance(BodyStyleSection);
